<template>
 <div
   class="group relative px-4 py-3 rounded-xl bg-gray-50 border border-gray-100 w-[270px] cursor-pointer hover:bg-white hover:border-violet-200 hover:shadow-md transition-all"
   @click="$emit('onClick')"
 >
  <button
    class="absolute z-10 top-1 right-1 p-1 opacity-0 group-hover:opacity-100 transition-opacity"
    @click.stop="handleDelete"
  >
   <img
     :src="close"
     alt="close"
     width="16"
     height="16"
   />
  </button>
  <ul class="text-left">
   <!-- <li class="text-[13px] leading-5 tracking-tight">대화 요약 : {{ summary }}</li> -->
   <li class="text-[13px] leading-5 tracking-tight">대화 생성 : {{ created_at.split('T')[0] }}</li>
   <li class="text-[13px] leading-5 tracking-tight">최근 대화 : {{ new Date(last_activity).toLocaleString('ko-KR', { 
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }) }}</li>
   <li class="text-[13px] text-ellipsis leading-5 tracking-tight overflow-hidden">
    <span class="whitespace-nowrap">
     활용 데이터 상세 : {{ summary }}
    </span>
   </li>
  </ul>
  <!-- <img
    :src="img"
    alt="project_img"
    onerror="this.className += ' bg-gray-02'"
    class="w-full overflow-hidden rounded-5 h-28"
  /> -->
 </div>
</template>

<script setup>
import { useStore } from 'vuex';
import close from '@/assets/close.svg'

const store = useStore();
const emit = defineEmits(['onClick', 'onDelete'])

const props = defineProps({
  id: {    // 세션 ID prop 추가
    type: Number,
    required: true
  },
  summary: {
   type: String,
   default: ''
  },
  created_at: {
   type: String,
   default: '',
  },
  last_activity: {
   type: String,
   default: '',
  },
  title: {
   type: String,
   default: '',
  },
  img: {
   type: String,
   default: '',
  },
  project_name: {
   type: String,
   default:'',
  }
})

const handleDelete = async (e) => {
  e.stopPropagation();
  try {
    const result = await store.dispatch('chat/deleteChatSession', props.id);
    emit('onDelete', result.message);
  } catch (error) {
    console.error('Failed to delete chat session:', error);
    emit('onDelete', '채팅 삭제에 실패했습니다');
  }
}
</script>
